import { useCallback, useEffect, useRef, useState } from "react";
import { ContractService } from "../../../core/services/ContractService";
import { Singleton } from "../../../core/services/Singleton";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { AdquisitionItemBudgetID } from "../AdquisitionItemBudgetID";
import { AdquisitionItemForm } from "../AdquisitionItemForm";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { AdquisitionArticle } from "./AdquisitionArticle";
import { useDashboardStore } from "../../pages/hooks/useDashboardStore";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { ITEM_ADMIN, ITEM_CONSOLIDATOR, ITEM_JEFE, ITEM_PREPARADOR } from "../../Constants";
import { OfferEmployee } from "../FlowHiring/OfferEmployee/OfferEmployee";
import { ChartArea } from "../../theme/charts/ChartArea";
import { _AdquisitionItem, _BusinessProcess, _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectAdquisitionItemConstan } from "./SelectAdquisitionItemConstan";
import { toast } from "react-toastify";
import { AdquisitionItemCDP } from "../etapa-contrato/contrac/AdquisitionItemCDP/AdquisitionItemCDP";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { ErrorList } from "../../theme/Component/ErrorList";
import { DropDown } from "../../theme/Component/DropDown";
import AutoChart, { HeadColumn } from "../../../core/graph/AutoChart";
import { ContractFiles } from "../etapa-contrato/ContractFiles";
import { useRequiredFields } from "../../theme/Component/hooks/useRequiredFields";
import { PlanEvents } from "../supplier/PlanEvents";
import { EditorExpedientDocumentFile } from "../../DocumentManagement/Management/DocumentFileManager/EditorExpedientDocumentFile";
import useProjectValidations, { ProjectValidationType } from "../../theme/Component/hooks/useProjectValidations";

interface Props {
    idAdquisitionPlanFunctionalID: number;
    selectRow?: any;
    rol: number;
    beanOficina: any;
    phaseState?: number;
    idPreparer?: number;
    // filterState?: number;
    filterStateArray?: any[];
    newItemData?: any;
}

//items del plan desde la vista de las areas 
export const AdquisitionItem = ({ idAdquisitionPlanFunctionalID, selectRow, rol, beanOficina, phaseState, idPreparer, filterStateArray, newItemData }: Props) => {
    const _busProcess = useDataBean(_BusinessProcess);
    const { instance } = useDataBean(_AdquisitionItem);
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new ContractService();
    const [lista, setLista] = useState([]);
    const [listaGra, setListaGra] = useState<any>([]);
    const [types, setTypes] = useState<any>([]);
    const [ListaTypes, setListaTypes] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const originalTotalValueRef = useRef<number | null>(null);
    const [invalid, setInvalid] = useState<boolean>(false)

    const [listaHistorico, setHistorico] = useState<any>([]);
    const [obs, setObs] = useState<string | undefined>('');
    const [nueva, setNueva] = useState<boolean>((phaseState ?? 0) === 2 ? true : false);//si es nueva necesidad 100 plan 101 nueva necesidad 

    //Modales
    const [modalRubro, setModalRubro] = useState<any>({ name: 'Rubros', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalItem, setModalItem] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalArticulo, setModalArticulo] = useState<any>({ name: 'Articulos', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalHistory = useModal("Historial de modificaciones", MODAL_LG);

    const modalEstado = useModal("Estado necesidad", MODAL_md);
    const modalReturn = useModal("Devolver a Preparador", MODAL_md);
    // const modalAnalyst = useModal("Analista", MODAL_LG);
    const [modalAnalyst, setModalAnalist] = useState<any>({ name: 'Equipo de Trabajo', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalHistorico, setModalHistorico] = useState<any>({ name: 'Histórico de Aprobaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalInfoArticles, setModalInfoArticles] = useState<any>({ name: 'Información de Estados de los Artículos del Plan', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalSend, setModalSend] = useState<any>({ name: 'Enviar a Responsable del Área para revisión', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAprobe, setModalAprobe] = useState<any>({ name: 'Aprobar item', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalRequest, setModalRequest] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalSwap, setModalSwap] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const modalcdp = useModal("CDP", MODAL_md);
    const modalGraph = useModal("Necesidades", MODAL_XL);
    const modalDocs = useModal("Expediente", MODAL_XL);
    const [actualValue, setActualValue] = useState<number>(0);

    const idBean = 'IDAdquisitionItem';


    const head = [
        { title: 'IDPAA', property: idBean, mask: MASK_NUMBER, visible: true },
        { title: 'Código', property: 'CodeItem' },
        { title: 'Necesidad', property: 'Description' },
        { title: 'Justificación', property: 'Justification', visible: false },
        { title: 'Rubro', property: 'IDLnBudgetIDNameList' },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Valor Estimado', property: 'TotalValue', mask: MASK_MONEY },
        { title: 'Valor Bien/Servicio', property: 'TotalArticle', mask: MASK_MONEY, visible: false },
        // { title: 'PI', property: 'PIValue', mask: MASK_MONEY, visible: true },
        // { title: 'CC', property: 'CCValue', mask: MASK_MONEY, visible: false },
        // { title: 'PF', property: 'PFValue', mask: MASK_MONEY, visible: true },
        // { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY, visible: false },
        // { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY, visible: false },
        // { title: 'Saldo CDP', property: 'LeftValue', mask: MASK_MONEY, visible: false },
        // { title: 'RP', property: 'RPValue', mask: MASK_MONEY, visible: false },

        { title: 'PI', property: 'PITotal', mask: MASK_MONEY, visible: false },
        { title: 'CC', property: 'CCTotal', mask: MASK_MONEY, visible: false },
        { title: 'PF', property: 'PFTotal', mask: MASK_MONEY, visible: true },
        { title: 'CDP', property: 'CDPTotal', mask: MASK_MONEY, visible: false },
        { title: 'RCDP', property: 'RCDPTotal', mask: MASK_MONEY, visible: false },
        { title: 'Saldo CDP (PF - CDP + RCDP)', property: 'LeftValue', mask: MASK_MONEY, visible: true },
        { title: 'RP', property: 'RPTotal', mask: MASK_MONEY, visible: true },
        { title: 'RRP', property: 'RRPTotal', mask: MASK_MONEY, visible: false },
        { title: 'OB', property: 'OBTotal', mask: MASK_MONEY, visible: false },
        { title: 'Saldo RP (RP - RRP - OB)', property: 'RPSaldo', mask: MASK_MONEY, visible: true },
        { title: 'CE', property: 'CETotal', mask: MASK_MONEY, visible: false },

        { title: 'Modalidad de selección', property: 'ModalityName', visible: true },
        { title: 'Dias Estructuracón', property: 'StructureDays', visible: true, mask: MASK_NUMBER },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Mes Contrato', property: 'MonthName2', visible: true },
        { title: 'Código Unspsc', property: 'NameUnscp', visible: false },
        { title: 'Iniciativa Estratégica', property: 'NameIniciative', visible: false },
        { title: 'Dependencia Solicitante', property: 'IDLnFunctionalIDName', visible: false },
        { title: "Preparador", property: "PreparerName", visible: false },
        { title: "Analista", property: "AnalystName", visible: false },
        { title: "Estado", property: "PreparationStateName" },
    ]
    const headGraph: HeadColumn[] = [
        { title: 'ID', property: idBean, mask: MASK_NUMBER, visible: true },
        { title: 'Código', property: 'CodeItem', visible: true },
        { title: 'Necesidad', property: 'Description', visible: true },
        { title: 'Justificación', property: 'Justification', visible: false },
        { title: 'Modalidad de selección', property: 'ModalityName', visible: false },
        { title: 'Rubro', property: 'IDLnBudgetIDNameList', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Valor Estimado', property: 'TotalValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Bien/Servicio', property: 'TotalArticle', visible: true, mask: MASK_MONEY, },

        { title: 'PI', property: 'PITotal', mask: MASK_MONEY },
        { title: 'CC', property: 'CCTotal', mask: MASK_MONEY },
        { title: 'PF', property: 'PFTotal', mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPTotal', mask: MASK_MONEY },
        { title: 'RCDP', property: 'RCDPTotal', mask: MASK_MONEY },
        { title: 'Saldo CDP (PF - CDP + RCDP)', property: 'LeftValue', mask: MASK_MONEY, visible: true },
        { title: 'RP', property: 'RPTotal', mask: MASK_MONEY, visible: true },
        { title: 'RRP', property: 'RRPTotal', mask: MASK_MONEY, visible: true },
        { title: 'OB', property: 'OBTotal', mask: MASK_MONEY, visible: true },
        { title: 'Saldo RP (RP - RRP - OB)', property: 'RPSaldo', mask: MASK_MONEY, visible: true },
        { title: 'CE', property: 'CETotal', mask: MASK_MONEY, visible: true },


        // { title: 'PI', property: 'PIValue', mask: MASK_MONEY, visible: true },
        // { title: 'CC', property: 'CCValue', mask: MASK_MONEY, visible: false },
        // { title: 'PF', property: 'PFValue', mask: MASK_MONEY, visible: true },
        // { title: 'CDP', property: 'CDPValue', mask: MASK_MONEY, visible: false },
        // { title: 'RCDP', property: 'RCDPValue', mask: MASK_MONEY, visible: false },
        // { title: 'Saldo CDP', property: 'LeftValue', mask: MASK_MONEY, visible: true },
        // { title: 'RP', property: 'RPValue', mask: MASK_MONEY, visible: true },

        { title: 'Nota', property: 'Note', visible: false },
        { title: 'Mes', property: 'MonthName', visible: false },
        { title: 'Mes Contrato', property: 'MonthName2', visible: true },
        { title: 'Código Unspsc', property: 'NameUnscp', visible: false },
        { title: 'Iniciativa Estratégica', property: 'NameIniciative', visible: true },
        { title: 'Dependencia Solicitante', property: 'IDLnFunctionalIDName', visible: true },
        { title: "Preparador", property: "PreparerName", visible: true },
        { title: "Analista", property: "AnalystName", visible: false },
        { title: "Estado", property: "PreparationStateName", visible: true },
    ]

    const headHistorico = [
        { title: 'Fecha', property: 'EventDate' },
        { title: 'Identificación', property: 'AccountID' },
        { title: 'Nombre', property: 'AccountName' },
        { title: 'Aprobado', property: 'Approved', visible: false },
        { title: 'Descripción', property: 'Description' },
        { title: 'Estado', property: 'sh se ' }
    ]


    useEffect(() => {
        // getPlan();
        getManagementTypeForIDLn();
        getLista();
    }, [idAdquisitionPlanFunctionalID, idPreparer])

    useEffect(() => {
        console.log("ejecutar")
        getManagementTypeForIDLn();


    }, [idAdquisitionPlanFunctionalID])

    const renderEstados = (item: any) => {

        let render = item.DataBeanProperties.PhaseState;
        if (item.DataBeanProperties.PhaseState === 0) {
            render = item.DataBeanProperties.PlanningStateName;
        }
        else if (item.DataBeanProperties.PhaseState === 1) {
            render = item.DataBeanProperties.StructuringStateName;
        }
        else if (item.DataBeanProperties.PhaseState === 2) {
            render = item.DataBeanProperties.HiringStateName;
        }
        return render;
    }

    const getManagementTypeForIDLn = useCallback(() => {

        if (idAdquisitionPlanFunctionalID > 0)
            service.getManagementTypeForIDLn(beanOficina.IDLnFunctionalID).subscribe(
                (resp: any) => {
                    console.log(resp);

                    if (resp.DataBeanProperties.ObjectValue) {

                        let t = resp.DataBeanProperties.ObjectValue;
                        let lis = [];
                        if (t.length > 0) {
                            let primero = t[0].DataBeanProperties;
                            lis = primero.JsonType ? JSON.parse(primero.JsonType) : [];
                        }

                        setTypes(lis);


                        if (lis.length > 0)
                            getManagementTypeConstants(lis);
                    }
                }
            );
    }, [beanOficina.IDLnFunctionalID])

    const getManagementTypeConstants = (listaTypes: any) => {

        service.getManagementTypeConstants().subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let tmp = [];
                    let lista = resp.DataBeanProperties.ObjectValue;
                    lista.forEach(element => {
                        if (listaTypes.includes(element.DataBeanProperties.Value)) {
                            tmp.push(element)
                        }
                    });
                    setListaTypes(tmp);
                    console.log(tmp)
                }
            }
        )


    }

    const validateValue = (item: any) => {
        const TotalValue = item.TotalValue;
        const TotalArticle = item.TotalArticle;
        let text = "";
        if (TotalArticle > TotalValue)
            text = "<span class='text-primary'>Bienes/Servicios superan el valor de la necesidad</span>";
        else if (TotalValue == 0)
            text = "<span class='text-primary'>Necesidad no tiene valor asignado</span>";

        return text;
    }

    const getLista = () => {



        if (idPreparer && idAdquisitionPlanFunctionalID) {
            service.getAdquisitionItemByFuncionalIDAndPreparer(idPreparer, 1, 100).subscribe(
                (resp: any) => {
                    console.log(resp.DataBeanProperties.ObjectValue);

                    if (resp.DataBeanProperties.ObjectValue) {
                        let ll = resp.DataBeanProperties.ObjectValue.DataBeanProperties.List;
                        setLista(ll);
                    }
                }
            );
        } else {
            if (idAdquisitionPlanFunctionalID) {
                setLoading(true);
                service.getAdquisitionItemByFuncionalID(idAdquisitionPlanFunctionalID, null, null, null).subscribe(
                    (resp: any) => {

                        if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                            let ll = resp.DataBeanProperties.ObjectValue.DataBeanProperties.List;


                            if (filterStateArray != undefined)
                                if (filterStateArray.length > 0) {
                                    console.log("FILTRANDO => ", filterStateArray);
                                    ll = ll.filter(ele => filterStateArray.includes(ele.DataBeanProperties.PreparationState));
                                }

                            ll.forEach((element: any) => {
                                element.DataBeanProperties.Estados = renderEstados(element);
                                element.DataBeanProperties.Note = validateValue(element.DataBeanProperties);

                            });

                            setLista(ll);
                        }

                        setLoading(false);
                    }
                );
            }
        }
    }

    const agregarItem = () => {
        console.log(newItemData)
        let b: any = {
            IDAdquisitionPlanFunctionalID: idAdquisitionPlanFunctionalID,
            TypeManagment: 100,
            Description: '',
            EstimatedValue: 0,
            ItemOrder: 1,
            ExecutionMonth: 0,
            EstimatedMonths: 1,
            IDLnBudgetID: 0,
            Justification: '',
            IDFunctionalIDPreparer: beanOficina.IDFunctionalIDPreparer != null ? beanOficina.IDFunctionalIDPreparer : 0,
        }

        if (newItemData) {
            b = {
                ...b,
                Justification: newItemData?.JustifyItem,
                TotalValue: newItemData?.Amount,
            }
        }

        originalTotalValueRef.current = null;
        setBean(b);
        setModalItem({ ...modalItem, "view": true, "name": 'Agregar Ítem' });
    }

    const updateState = (objeto: any) => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.")
            setInvalid(true);
        } else {
            _single.spinner(true);
            service.changeAdquisitionItemApprovalNote(objeto.IDAdquisitionItem, _single.getAccountID(), obs, objeto.PreparationState).subscribe(
                (resp: any) => {
                    setInvalid(false)
                    setObs("")
                    getLista();
                    _single.spinner(false);
                    setModalConfirm({ ...modalConfirm, "view": false });
                    modalReturn.close();
                    modalEstado.close();
                    setModalAprobe({ ...modalAprobe, "view": false });
                    setModalSend({ ...modalSend, "view": false });
                }
            )
        }
    }


    const { missingFields, validate } = useRequiredFields(bean, (b) => {
        const base: Array<keyof typeof bean> = [
            "TypeManagment",
            "TotalValue",
            "Justification",
            "Description",
            "ExecutionMonth",
        ];

        if (b.TypeManagment === 101) base.push("IDProject");
        return base;
    })

    const projectValidation = useProjectValidations(bean.IDProject);

    const updateMItem = () => {
        if (validate() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        }

        let obj = { ...bean };

        obj.TypeAdquisition = nueva ? 101 : 100;
        const normalizeTotalValue = (value: any) => {
            const numericValue = Number(value ?? 0);
            return Number.isFinite(numericValue) ? numericValue : 0;
        };
        const currentTotalValue = normalizeTotalValue(obj.TotalValue);
        const originalTotalValue = originalTotalValueRef.current;
        const isNewItem = !obj.IDAdquisitionItem;
        const totalValueChanged = !isNewItem && originalTotalValue !== null && currentTotalValue !== originalTotalValue;
        const shouldValidateProjectBalance = obj.TypeManagment === 101 && (isNewItem || totalValueChanged);

        if (shouldValidateProjectBalance) {
            const projectValidationResult = projectValidation.validate({
                type: ProjectValidationType.ADQUISITION_ITEM,
                totalValue: currentTotalValue,
            });

            if (!projectValidationResult.canModify) {
                projectValidation.showAlerts(projectValidationResult.alerts);
                return;
            }
        }

        instance.updateAdquisitionItem({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                getLista();
                setModalItem({ ...modalItem, view: false });
            }
        ).catch(err => {
            console.log(err);
            toast.error("No se pudo actualizar");
        });
    };

    const eliminarItem = () => {
        let obje = bean;
        obje.PreparationState = 8;
        updateState(obje);
    }

    const editarMItem = () => {
        const numericValue = Number(bean.TotalValue ?? 0);
        originalTotalValueRef.current = Number.isFinite(numericValue) ? numericValue : 0;
        setModalItem({ ...modalItem, "view": true, "name": 'Editar' });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', icono: 'ri-file-add-line', visible: rol === ITEM_CONSOLIDATOR ? true : single.canCreate(), evento: agregarItem },
        {
            nombre: 'Solicitar Necesitad a Otra Area', icono: 'ri-file-transfer-line', visible: rol === ITEM_CONSOLIDATOR ? true : single.canCreate(), evento: () => {
                setSelectedAction("SOLNPAA");
                setModalRequest({ ...modalRequest, view: true, name: "Solicitud Nueva Necesidad" });
            }
        }
    ]

    const validateCanCancel = () => {
        // if (rol === ITEM_PREPARADOR) {
        //     const invalidStates = [40, 41, 42, 43, 7, 31];
        //     const validStates = [];
        //     return single.canDelete() && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        // } else if (rol === ITEM_JEFE) {
        //     const invalidStates = [40, 41, 42, 43, 7, 8];
        //     return single.canDelete() && !invalidStates.includes(bean.PreparationState);
        // if (rol == ITEM_ADMIN) {
        //     const invalidStates = [40, 41, 42, 43, 7, 31];
        //     return !invalidStates.includes(bean.PreparationState);
        // } else {
        //     const invalidStates = [8]
        //     return false;
        // }

        const invalidStates = [43, 30, 3, 4, 7, 9];
        return invalidStates.includes(bean.PreparationState);
    };

    const validateCanEdit = () => {
        if (rol == ITEM_ADMIN) {
            return true;
        } else if (rol == ITEM_CONSOLIDATOR) {
            return true;
        } else {

            const validStates = [30, 27, 9];
            return single.canEdit() && validStates.includes(bean.PreparationState);
        }
    }

    const validateSendBossRevision = () => {
        if (rol == ITEM_PREPARADOR) {
            const validStates = [30, 27, 9];
            return rol === ITEM_PREPARADOR && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_JEFE) {
            const validStates = [30, 27, 9];
            return rol === ITEM_JEFE && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateCDP = () => {
        if (rol == ITEM_PREPARADOR) {
            const validStates = [];
            return rol === ITEM_PREPARADOR && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_JEFE) {
            const validStates = [6, 44, 40, 41, 42, 43, 44, 12];
            return rol === ITEM_JEFE && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const validStates = [6, 44, 40, 41, 42, 43, 44, 12];
            return rol === ITEM_ADMIN && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateRequestCC = () => {
        if (rol == ITEM_PREPARADOR) {
            const validStates = [];
            return rol === ITEM_PREPARADOR && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_JEFE) {
            const validStates = [];
            return rol === ITEM_JEFE && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const validStates = [44, 40, 41, 42, 43, 44, 12, 6];
            return rol === ITEM_ADMIN && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateReturnPreparer = () => {
        if (rol == ITEM_JEFE) {
            const invalidStates = [4, 8]
            const validStates = [31];
            return rol === ITEM_JEFE && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const invalidStates = [4, 8]
            const validStates = [31];
            return rol === ITEM_ADMIN && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateSolOfertas = () => {
        if (rol == ITEM_JEFE) {
            const invalidStates = [4, 8]
            const validStates = [];
            return rol === ITEM_JEFE && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const invalidStates = [4, 8]
            const validStates = [40];
            return rol === ITEM_ADMIN && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateSolCDP = () => {
        if (rol == ITEM_JEFE) {
            const invalidStates = [4, 8]
            const validStates = [];
            return rol === ITEM_JEFE && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const invalidStates = [4, 8]
            const validStates = [6];
            return rol === ITEM_ADMIN && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateEPrevio = () => {
        if (rol == ITEM_JEFE) {
            const invalidStates = [4, 8]
            const validStates = [];
            return rol === ITEM_JEFE && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const invalidStates = [4, 8]
            const validStates = [44];
            return rol === ITEM_ADMIN && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateEPrecontractual = () => {
        if (rol == ITEM_JEFE) {
            const invalidStates = [4, 8]
            const validStates = [];
            return rol === ITEM_JEFE && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else if (rol == ITEM_ADMIN) {
            const invalidStates = [4, 8]
            const validStates = [40];
            return rol === ITEM_ADMIN && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const validateSolApprove = () => {
        if (rol == ITEM_JEFE) {
            const invalidStates = [4, 8]
            const validStates = [31];
            return rol === ITEM_JEFE && !invalidStates.includes(bean.PreparationState) && validStates.includes(bean.PreparationState);
        } else {
            return (false)
        }
    }

    const [msgList, setMsgList] = useState<any>([])
    const [modalErr, setModalErr] = useState<any>({ name: "", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md" });

    useEffect(() => {
        if (msgList.length > 0) {
            setModalErr({ ...modalErr, "view": true, "name": "Errores en la Necesidad" })
        }
    }, [msgList])


    const validateAndProceed = (execute: () => void) => {
        instance.validateAdquisitionItem(bean.IDAdquisitionItem)
            .then((resp) => {
                if (resp.length > 0) {
                    toast.error("No se puede continuar. Hay errores en la validación.");
                    setMsgList(resp)
                } else {
                    execute();
                }
            })
            .catch(err => {
                console.error("Error en validación:", err);
                toast.error("Ocurrió un error en la validación.");
            });
    };

    const listaBotonesItems = () => {
        const invalidStates = [8];
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: validateCanEdit(), evento: editarMItem },
            { titulo: 'Cancelar', icono: 'ri-delete-bin-2-line', visible: validateCanCancel(), evento: () => { setModalConfirm({ ...modalConfirm, 'view': true, "name": `Cancelar Necesidad ${bean.IDAdquisitionItem}` }) } },
            { titulo: 'Rubros', icono: 'ri-git-branch-line', visible: !invalidStates.includes(bean.PreparationState), evento: () => { setModalRubro({ ...modalRubro, "view": true }) } },
            { titulo: 'Bien/Servicio', icono: 'ri-file-list-line', visible: true, evento: () => { setModalArticulo({ ...modalArticulo, 'view': true }) } },
            { titulo: 'Cambiar estado', icono: 'ri-exchange-line', visible: rol === ITEM_ADMIN, evento: () => { modalEstado.open() } },
            { titulo: 'Devolver a Preparador', icono: 'ri-arrow-go-back-line', visible: validateReturnPreparer(), evento: () => { modalReturn.open() } },
            { titulo: 'Equipo de trabajo', icono: 'bx bxs-user-check', visible: (rol === ITEM_ADMIN && !invalidStates.includes(bean.PreparationState)), evento: () => { setModalAnalist({ ...modalAnalyst, "view": true, "name": `Equipo de Trabajo ${bean.IDAdquisitionItem ? `de la Necesidad Identificada con ID ${bean.IDAdquisitionItem}` : ""}` }) } },
            { titulo: 'Ver histórico de aprobaciones', icono: 'ri-file-history-line', visible: true, evento: () => { seeHisotryApproval() } },
            { titulo: 'Ver Expediente Asociado', icono: 'ri-file-history-line', visible: true, evento: () => { modalDocs.open() } },
            { titulo: 'Enviar a Responsable del Área para revisión', icono: 'ri-mail-send-line', visible: validateSendBossRevision(), evento: () => { setModalSend({ ...modalSend, "view": true }) } },

            // { titulo: 'Aprobar Estructuracion del Item', icono: 'bx bx-check', visible: (rol == ITEM_JEFE && bean.PreparationState == 31), evento: () => { setModalAprobe({ ...modalAprobe, "view": true }) } },
            { titulo: 'CDP Asociados', icono: 'ri-file-list-line', visible: validateCDP(), evento: () => { modalcdp.open(); } },
            {
                titulo: 'Solicitud Crédito/ContraCrédito', icono: 'ri-send-plane-line', visible: validateRequestCC(), evento: () => {
                    setSelectedAction("SOLCCAI");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud de ContraCredito" });
                }
            },
            {
                titulo: 'Solicitar Ofertas', icono: 'ri-play-list-add-line', visible: validateSolOfertas(), evento: () => {
                    setSelectedAction("SOLOFERTA");
                    setModalRequest({ ...modalRequest, view: true, name: "Iniciar Solicitud de Oferta" });
                }
            },
            {
                titulo: 'Solicitar CDP', icono: 'ri-play-list-add-line', visible: validateSolCDP(), evento:
                    () => validateAndProceed(() => {
                        setSelectedAction("SOLCDPAI");
                        setModalRequest({ ...modalRequest, view: true, name: "Solicitar CDP" });
                    })
            },
            {
                titulo: 'Solicitud Estudio Previo', icono: 'ri-play-list-add-line', visible: validateEPrevio(), evento: () => {
                    setSelectedAction("EPREVIO");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud Estudio Previo" });
                }
            },
            {
                titulo: 'Solicitud Fase Precontractual', icono: 'ri-play-list-add-line', visible: validateEPrecontractual(), evento: () => {
                    setSelectedAction("SPRECON");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud Fase Precontractual" });
                }
            },
            {
                titulo: 'Solicitud Aprobación Estructuración de la Necesidad', icono: 'ri-play-list-add-line', visible: validateSolApprove(), evento: () => {
                    setSelectedAction("APPROVEITEM");
                    setModalRequest({ ...modalRequest, view: true, name: "Solicitud Aprobación de la Necesidad" });
                }
            },
            { titulo: 'Ver Modificaciones', icono: 'ri-git-commit-line', visible: true, evento: () => { modalHistory.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const aprobarItem = () => {
        let b = bean;
        b.PreparationState = 4;
        updateState(b)
    }

    const seeHisotryApproval = () => {
        setModalHistorico({ ...modalHistorico, "view": true });
        setLoading(true);
        service.getAdquisitionItemApprovalNoteCatalog(bean.IDAdquisitionItem, null, null, null).subscribe(
            (resp: any) => {
                //console.log(resp);
                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    setHistorico(resp.DataBeanProperties.ObjectValue.DataBeanProperties.List);
                }
                setLoading(false);
                single.makeAcction("El usuario consultó el histórico de aprobaciones del ítem " + (bean.IDAdquisitionItem), bean);
            }
        )
    }

    const sendItemApporval = () => {
        let obje = bean;
        obje.PreparationState = 31;
        updateState(bean);
    }

    const setRow = (item: any) => {
        setBean(item);
        if (selectRow)
            selectRow(item);

    }

    const [selectedAction, setSelectedAction] = useState<string>("");
    const [isValid, setIsValid] = useState<boolean>(false);

    const handleModalSubmit = () => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true);
            return;
        }

        setIsValid(false);

        const initProps = { IDAdquisitionItem: bean.IDAdquisitionItem };

        let processType = "";
        switch (selectedAction) {
            case "SOLOFERTA":
                processType = "SOLOFERTA";
                break;
            case "SOLCDPAI":
                processType = "SOLCDPAI";
                break;
            case "EPREVIO":
                processType = "EPREVIO";
                break;
            case "SOLCCAI":
                processType = "SOLCCAI";
                break;
            case "APPROVEITEM":
                processType = "APPROVEITEM";
                break;
            case "SOLNPAA":
                processType = "SOLNPAA";
                break;
            case "SPRECON":
                processType = "SPRECON";
                break;
            default:
                return;
        }

        _busProcess.instance.requestBusinessProcess(
            _single.getAccountID(),
            obs,
            processType,
            "IDAdquisitionItem",
            bean.IDAdquisitionItem,
            JSON.stringify(initProps),
            ""
        )
            .then((resp) => {
                toast.success(`Se ha Generado el Proceso ${resp.AlphaCode}`, { autoClose: false });
                let b = bean;
                b.PreparationState = 43;
                setModalRequest({ ...modalRequest, "view": false })
                if (bean.IDAdquisitionItem) {
                    updateState(b);
                }
            })
            .catch(err => console.log(err));
    };

    const actions = (e: any) => {
        console.log(e);
        if (e.id === 1) {
            modalGraph.open();
        }

    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Grafico', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} iconButtons={iconButtonsItem} listButtons={listaBotonesItems()} head={head} body={lista} rowSet={setRow}></BasicTable>
                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal}>
                        <PlanEvents type={2} idBean={bean.IDAdquisitionItem} />
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalErr} updateModal={setModalErr}>
                        <ErrorList lista={msgList} />
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalcdp.modal} updateModal={modalcdp.setModal}>
                        <AdquisitionItemCDP adquisitionItem={bean} />
                    </Modal>
                </div>
                <div className="col-md-12">
                    {modalItem.view &&
                        <Modal modal={modalItem} updateModal={setModalItem} eventModal={() => { updateMItem() }}>
                            {projectValidation.notes.map((note, index) => (
                                <div
                                    key={`${note.message}-${index}`}
                                    className={`alert alert-${note.severity === "error" ? "danger" : note.severity}`}
                                    role="alert"
                                >
                                    {note.message}
                                </div>
                            ))}
                            <AdquisitionItemForm
                                beanItem={bean}
                                setBeanItem={setBean}
                                rol={rol}
                                ListaTypes={ListaTypes}
                                missingFields={missingFields}
                            />
                        </Modal>
                    }

                    {/* articulos de la necesidad  */}
                    {modalArticulo.view &&
                        <Modal modal={modalArticulo} updateModal={setModalArticulo}>
                            <div className="row">
                                <div className="col-md-12">
                                    <AdquisitionArticle rolModify={rol} adquisitionItem={bean} updateFather={() => { getLista() }} beanItem={bean}></AdquisitionArticle>

                                </div>
                            </div>
                        </Modal>
                    }

                    {/* rubros de la necesidad  */}
                    {modalRubro.view &&
                        <Modal modal={modalRubro} updateModal={setModalRubro} eventModal={() => { }}>
                            <div className="row">
                                <div className="col">

                                    <AdquisitionItemBudgetID rolModify={rol} CanModify={bean.PreparationState} adquisitionItem={bean} iDBudgetIDType={bean.IDBudgetIDType} estimateValue={bean.TotalValue} onChange={getLista} />
                                </div>
                            </div>
                        </Modal>
                    }

                    {/* estados de la necesidad */}
                    <Modal modal={modalEstado.modal} updateModal={modalEstado.setModal} eventModal={() => { updateState(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <SelectAdquisitionItemConstan idSelector={bean.PreparationState} onChange={(e) => { setBean({ ...bean, "PreparationState": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="obs" className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalReturn.modal} updateModal={modalReturn.setModal} eventModal={() => { updateState(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <SelectAdquisitionItemConstan idSelector={bean.PreparationState} onChange={(e) => { setBean({ ...bean, "PreparationState": e }) }} filter={[27, 9]} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="obs" className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalAnalyst} updateModal={setModalAnalist} eventModal={() => { setModalAnalist({ ...modalAnalyst, "view": false }); getLista() }}>
                        <OfferEmployee IDAdquisitionItem={bean.IDAdquisitionItem} />
                    </Modal>

                    <Modal onSubmitLabel="Solicitar" modal={modalRequest} updateModal={setModalRequest} eventModal={handleModalSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea
                                    name="obs"
                                    rows={5}
                                    className={`form-control ${isValid ? "is-invalid" : ""}`}
                                    value={obs}
                                    onChange={(e) => setObs(e.target.value)}
                                />
                            </div>
                        </div>
                    </Modal>

                    <Modal onSubmitLabel="Solicitar" modal={modalSwap} updateModal={setModalSwap} eventModal={handleModalSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Justificación de la Solictiud</label>
                                <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalDocs.modal} updateModal={modalDocs.setModal} >
                        {/* <ContractFiles IDAdquisitionContract={bean.IDAdquisitionContract} IDAdquisitionItem={bean.IDAdquisitionItem} IDHiringModality={bean.IDHiringModality} /> */}
                        <EditorExpedientDocumentFile _ClassForName="com.orange.bean.supplier.AdquisitionItem" _IDClass={bean.IDAdquisitionItem} />
                    </Modal>

                    <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                        {bean.Description}
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="obs" className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                        </div>
                    </ModalConfirm>

                    {modalAprobe.view &&
                        <Modal modal={modalAprobe} updateModal={setModalAprobe} eventModal={aprobarItem} >
                            <p>Cambiar el item a estado aprobado ? </p>
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Observaciones</label>
                                    <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                                </div>
                            </div>
                        </Modal>
                    }

                    {modalHistorico.view &&
                        <Modal modal={modalHistorico} updateModal={setModalHistorico} >
                            <BasicTable head={headHistorico} body={listaHistorico} rowSet={() => { }}></BasicTable>
                        </Modal>
                    }

                    {modalSend.view &&
                        <Modal modal={modalSend} updateModal={setModalSend} eventModal={sendItemApporval} >
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Observaciones</label>
                                    <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                                </div>
                            </div>
                        </Modal>
                    }

                    {modalInfoArticles.view &&
                        <Modal modal={modalInfoArticles} updateModal={setModalInfoArticles} >
                            <ChartArea lista={listaGra} maxRang={100} titulo="Estados" tipo="bar"></ChartArea>
                        </Modal>
                    }

                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={headGraph} useIndexAsXLabel={true}
                            xOptions={['ModalityName', 'Rubro', 'ProjectName', 'NameProject', 'IDLnFunctionalIDName', 'Estado', 'Description', 'MonthName', 'MonthName2']}
                            yOptions={['PITotal', 'CCTotal', 'PFTotal', 'CDPTotal', 'RCDPTotal', 'LeftValue', 'RPTotal', 'RRPTotal', 'OBTotal', 'RPSaldo', 'CETotal']} />
                        {/* <PrintJson json={lista}/> */}
                    </Modal>
                </div>
            </div>

        </>
    )
}
